import React, { useEffect, useState } from "react";
import { matchPath, Route, Switch, withRouter } from "react-router-dom";
import { history } from "./store";

import useDidMountEffect from "../../hooks/useDidMountEffect";
import DomainModal from "./modals/DomainModal";
import AdminOrgEditModal from "./modals/AdminOrgEditModal";
import appConfig from "../../appConfig";
import ManageMembersModal from "./modals/ManageMembersModal";
import WidgetInstallModal from "./modals/WidgetInstallModal";
import NewOrganizationSetup from "./modals/NewOrganizationSetup";

const ModalRoutesComponent = React.memo(
  (props) => {
    const [modalClosePath, setModalClosePath] = useState(null);

    useDidMountEffect(() => {
      updateModalClosePath();
    });

    useEffect(() => {
      setModalClosePath(null);
    }, [props.location.pathname]);

    /**
     *
     */
    const updateModalClosePath = () => {
      const modalLinkIndex = props.prevModalLocation.findIndex((modalLink) => {
        const match = matchPath(props.location.pathname, {
          path: modalLink,
          exact: true,
          strict: false,
        });

        return match !== null;
      });

      if (modalLinkIndex >= 0) {
        setModalClosePath(
          Object.values(props.prevModalLocation[modalLinkIndex])[0]
        );
      }
    };

    /**
     *
     */
    const onCloseAction = () => {
      if (modalClosePath) {
        history.push(modalClosePath);
      } else {
        history.goBack();
      }
    };
    const isAdmin = props.user.model && props.user.model.role == "admins";

    return (
      <Switch>
        <Route path="/domains/:uuid" component={DomainModal} />
        <Route
          path={`/${appConfig.links.organization}/edit/:uuid`}
          component={AdminOrgEditModal}
        />

        <Route path={"/manage-members"} component={ManageMembersModal} />
        <Route path={"/new-organization"} component={NewOrganizationSetup} />
        <Route
          path={"/install/:widgetType/:uuid"}
          component={WidgetInstallModal}
        />
      </Switch>
    );
  },
  (oldProps, newProps) => {
    if (oldProps.location.pathname !== newProps.location.pathname) {
      return false;
    } else {
      // don't update, locations are the same
      return true;
    }
  }
);

export default withRouter(ModalRoutesComponent);
